import { render, staticRenderFns } from "./Diamonds.vue?vue&type=template&id=78b6b3d0&"
import script from "./Diamonds.vue?vue&type=script&lang=js&"
export * from "./Diamonds.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports